import { render } from "./HeroiconsOutlineMenu.vue?vue&type=template&id=27b43e46"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMenu.vue"]])

export default __exports__